import { Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';

@Injectable({
    providedIn: 'root',
})
export class NavigationBrowserService {
    constructor(private router: Router) {}

    init() {
        this.addPopStateEventListener();
        this.disableBackButton();
    }

    private disableBackButton() {
        window.history.pushState(null, null, null);
        this.router.events.subscribe((event) => {
            if (event instanceof NavigationEnd) {
                window.history.pushState(null, null, null);
            }
        });
    }

    private addPopStateEventListener(): void {
        window.addEventListener('popstate', () => {
            window.history.pushState(null, null, null);
        });
    }
}
